import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { RegionType, RegionTypesKey } from '../@types/regionType.type';
import { getRegionTypes } from '../api/regionTypes';

export const useGetRegionTypes = (): UseQueryResult<RegionType[]> => {
  return useQuery({
    queryKey: [RegionTypesKey],
    queryFn: () => getRegionTypes(),
    staleTime: 2 * 60 * 60 * 1000
  });
};